import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from "axios"


export const getPodcasts = createAsyncThunk(
  "api/podcasts",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get("/api/admin/podcasts",); 
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch podcasts"
      );
    }
  }
);

export const getPodcastsClient = createAsyncThunk('admin/podcasts-client', async(id, {rejectWithValue}) => {
  try {
    console.log("id:", id);
    
    const response = await axios.get(`/api/admin/podcasts/client/${id}`)
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || "Failed to fetch podcasts");
  }
} )

const initialState = {
  podcasts:[] ,
  podcastsCopy: [],
  podcastsClient: [],
  podcast: null,
  stadistics: {
    transmitidosWeek: 120,
    totalPodcasts: 80,
    horas: 114
  },
  loading: false,
  error: null
};

const podcastSlice = createSlice({
  name: 'podcast',
  initialState,
  reducers: {
    setPodcast: (state, action) => {
        state.podcast = action.payload
    },
    sortPodcastsName: (state,action) => {
      const order = action.payload;
      if(state.podcasts){
        if(order === "asc" || order === "desc" ) {
          state.podcasts.sort((a,b) => {
            const nameA = a.name.toLowerCase();
            const nameB = b.name.toLowerCase();
            if(order === "asc"){
              return nameA.localeCompare(nameB) 
            } else if (order === "desc") {
              return nameB.localeCompare(nameA)
            }
            return 0
            
          })
        } else if (order === "") {
          state.podcasts = [...state.podcastsCopy];
        }
      }
    },
    filterByName: (state, action) => {
      const name = action.payload;
      if(name) {
        state.podcasts = state.podcastsCopy.filter(podcast => podcast.name.toLowerCase().includes(name.toLowerCase()) )
      } else {
        state.podcasts = [...state.podcastsCopy]
      }
    },
    sortNewIdea: (state, action) => {
      const order = action.payload;
      if (state.podcasts) {
        if (order === true || order === false) {
          state.podcasts.sort((a, b) => {
            const newIdeaA = a.newIdea;
            const newIdeaB = b.newIdea;
    
            if (order === true) {
              return newIdeaA === newIdeaB ? 0 : newIdeaA ? -1 : 1; 
            } else if (order === false) {
              return newIdeaA === newIdeaB ? 0 : newIdeaB ? -1 : 1; 
            }
            return 0;
          });
        } else if (order === null) {
          state.podcasts = [...state.podcastsCopy]; 
        }
      }
    },
    sortPlanActive: (state, action) => {
      const order = action.payload;
      if (state.podcasts) {
        if (order === true || order === false) {
          state.podcasts.sort((a, b) => {
            const newIdeaA = a.planActive;
            const newIdeaB = b.planActive;
    
            if (order === true) {
              return newIdeaA === newIdeaB ? 0 : newIdeaA ? -1 : 1; 
            } else if (order === false) {
              return newIdeaA === newIdeaB ? 0 : newIdeaB ? -1 : 1; 
            }
            return 0;
          });
        } else if (order === null) {
          state.podcasts = [...state.podcastsCopy]; 
        }
      }
    },
  },
  extraReducers: (builder) => {
    builder
    .addCase(getPodcasts.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(getPodcasts.fulfilled, (state,action) => {
      state.loading = false;
      state.podcasts = action.payload;
      state.podcastsCopy = action.payload;
    })
    .addCase(getPodcasts.rejected, (state,action) => {
      state.loading = false;
      state.error = action.payload
    })
    .addCase(getPodcastsClient.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(getPodcastsClient.fulfilled, (state,action) => {
      state.loading = false;
      state.podcastsClient = action.payload;
    })
    .addCase(getPodcastsClient.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    })
  }
    
});

export const {
    setPodcast, sortPodcastsName, filterByName, sortNewIdea, sortPlanActive
} = podcastSlice.actions;

export default podcastSlice.reducer;